import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { trackEvent } from "@/lib/analytics";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ContactForm = () => {
  const [form, setForm] = useState({ full_name: "", email: "", subject: "", message: "" });
  const [loading, setLoading] = useState(false);

  const editorialInput =
    "bg-transparent border-0 border-b border-ink-900/15 rounded-none h-12 px-0 text-ink-900 placeholder:text-ink-400 focus-visible:ring-0 focus-visible:border-sage";

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/contact`, {
        full_name: form.full_name,
        email: form.email,
        subject: form.subject || null,
        message: form.message,
      });
      trackEvent("generate_lead", { lead_type: "contact_enquiry" });
      toast.success("Message received", { description: "Our front desk will reply within the day." });
      setForm({ full_name: "", email: "", subject: "", message: "" });
    } catch (err) {
      const msg = err?.response?.data?.detail || "Something went wrong";
      toast.error(typeof msg === "string" ? msg : "Please try again");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={submit} data-testid="contact-form" className="space-y-8">
      <div className="grid md:grid-cols-2 gap-8">
        <div>
          <Label className="overline">Name</Label>
          <Input
            required
            data-testid="contact-input-name"
            value={form.full_name}
            onChange={(e) => setForm({ ...form, full_name: e.target.value })}
            className={editorialInput}
          />
        </div>
        <div>
          <Label className="overline">Email</Label>
          <Input
            required
            type="email"
            data-testid="contact-input-email"
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
            className={editorialInput}
          />
        </div>
      </div>
      <div>
        <Label className="overline">Subject (optional)</Label>
        <Input
          data-testid="contact-input-subject"
          value={form.subject}
          onChange={(e) => setForm({ ...form, subject: e.target.value })}
          className={editorialInput}
        />
      </div>
      <div>
        <Label className="overline">Message</Label>
        <Textarea
          required
          data-testid="contact-input-message"
          value={form.message}
          onChange={(e) => setForm({ ...form, message: e.target.value })}
          className="bg-transparent border border-ink-900/15 rounded-none min-h-[140px] text-ink-900 placeholder:text-ink-400 focus-visible:ring-0 focus-visible:border-sage"
        />
      </div>
      <Button
        type="submit"
        disabled={loading}
        data-testid="contact-submit-btn"
        className="h-12 px-10 bg-sage hover:bg-sage-dark text-paper-50 rounded-none text-[12px] tracking-[0.22em] uppercase"
      >
        {loading ? "Sending…" : "Send message"}
      </Button>
    </form>
  );
};

export default ContactForm;
